import React from 'react';

import type { Originator } from '../../../../../core/data-sources/content-components/types.js';

import BylineCarousel from './BylineCarousel/BylineCarousel.js';
import TimeStamp from '../articleComponents/Timestamp.js';
import Author from './Author.js';

type AuthorProps = {
  authors: Originator[];
  section: string;
  published?: string;
  updated?: string;
};

const Authors: React.FC<AuthorProps> = ({
  authors,
  published,
  updated,
  section,
}) => {
  const showCircle = authors.length === 1;
  const singleAuthor = authors[0];

  return (
    <>
      <div className="authors-wrapper">
        {published && updated && (
          <TimeStamp published={published} updated={updated} />
        )}

        <div className="authors-container">
          {authors.length === 1 ? (
            <Author
              {...singleAuthor}
              showCircle={showCircle}
              section={section}
            />
          ) : (
            <BylineCarousel
              authors={authors}
              showCircle={showCircle}
              section={section}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default Authors;
